// extracted by mini-css-extract-plugin
export default {"wrap":"k4pjcp3awJ5CiH1cGt5U","picture":"PZWoj_mnp81Oq7kQwRzl","main":"SAOSmXHjHJv_I_1U_rj_"};